<!-- 销售退货 新版支持同一商品多条明细 -->
<template>
    <div class="salereturn-order-edit">
        <div class="bread-nav">
            <el-button size="small" icon="el-icon-back" class="search-btn btn-primary" @click="goback()"></el-button>
            <!-- <el-button size="small" class="search-btn btn-primary" @click="showOrderDialog()" :disabled="dataReadonly || type == 1" tabindex="-1">按单售后(F2)</el-button> -->
            <el-button size="small" class="search-btn btn-primary" @click="showSearch()" :disabled="dataReadonly || type == 1" tabindex="-1">搜索销售明细(F2)</el-button>
            <el-button
                size="small"
                class="search-btn btn-primary"
                @click.stop="submitForm(0)"
                v-if="(type == 2 || type == 3 || type == 0) && permission.save"
                :disabled="stopSubmit"
                >{{ permission.save }}</el-button
            >
            <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm(1)" v-if="type != 1 && permission.submit" :disabled="stopSubmit">{{
                permission.submit
            }}</el-button>
        </div>
        <!--form-->
        <div class="section-title">
            <div>
                <span>售后订单信息</span>
                <!-- <span v-if="submitData.EntpCusOId != ''">关联的销售单号：{{ orderCode }}</span> -->
                <span v-if="returnCode != ''">售后单号：{{ returnCode }}</span>
            </div>
        </div>
        <div class="order-infoes">
            <el-form :model="submitData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="入仓仓库" prop="WarehouseId">
                                 <el-input
                                    v-if="
                                        dataReadonly ||submitData.WarehousedCount>0 ||submitData.IsERPOrder
                                    "
                                    :title="submitData.WarehouseName"
                                    v-model="submitData.WarehouseName"
                                    style="width: 100%"
                                    size="small"
                                    :disabled="true"
                                ></el-input>                                  
                                <el-select
                                    v-else
                                    v-model="submitData.WarehouseId"
                                    :disabled="dataReadonly||submitData.IsERPOrder"
                                    placeholder="请选择"
                                    style="width: 100%"
                                    size="small"
                                    filterable
                                    clearable
                                    @visible-change="warehouseVisibleChange($event)"
                                    @change="warehouseChange"
                                >
                                    <el-option
                                        v-for="optionItem in warehouseList"
                                        :key="optionItem.WarehouseId"
                                        :label="optionItem.WarehouseName"
                                        :value="optionItem.WarehouseId"
                                    >
                                        <span style="float: left">
                                            {{ optionItem.WarehouseName }}
                                        </span>
                                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="选择客户" prop="EntpCusId">
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    :disabled="submitData.EntpCusOId"
                                    v-model="submitData.EntpCusId"
                                    filterable
                                    clearable
                                    remote
                                    :remote-method="searchCustomer"
                                    v-select-scroll-more="searchCustomLoad"
                                    @visible-change="customerVisibleChange($event)"
                                    reserve-keyword
                                    placeholder="选择客户"
                                    @change="selectCustomerChange($event)"
                                >
                                    <el-option
                                        v-for="optionItem in customerList"
                                        :key="optionItem.EntpCusId"
                                        :data-msg="optionItem"
                                        :label="optionItem.EntpCusName"
                                        :value="optionItem.EntpCusId"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <!--售后单：财务未确认收款前，可更改客户-->
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="售后时间" prop="ReturnTime">
                                <el-date-picker
                                    style="width: 100%"
                                    size="small"
                                    :disabled="dataReadonly"
                                    v-model="submitData.ReturnTime"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                ></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5" v-if="isOrgShow">
                        <div class="grid-content bg-purple">
                            <el-form-item label="部门" prop="OrgId" key="org">
                                <el-input size="small" v-if="type == 1 || dataReadonly" disabled v-model="submitData.OrgName"></el-input>
                                <el-select
                                    style="width: 100%"
                                    size="small"
                                    v-else
                                    :disabled="(dataReadonly || isBPriceShow) && submitData.OrgId !== ''"
                                    v-model="submitData.OrgId"
                                    filterable
                                    clearable
                                    reserve-keyword
                                    @change="orgChange($event)"
                                    @visible-change="orgVisibleChange($event)"
                                    placeholder="请选择"
                                    :key="orgSelKey"
                                >
                                    <el-option v-for="optionItem in orgList" :key="optionItem.Id" :data-msg="optionItem" :label="optionItem.Name" :value="optionItem.Id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="isOrgShow ? 4 : 5" v-if="!isBPriceShow">
                        <div class="grid-content bg-purple">
                            <el-form-item label="源开单员" prop="OrderSId">
                                <el-input size="small" v-if="type == 1 || dataReadonly" disabled v-model="submitData.OrderSName"></el-input>
                                <el-select
                                    v-else
                                    v-model="submitData.OrderSId"
                                    :disabled="dataReadonly"
                                    filterable
                                    clearable
                                    placeholder="请选择"
                                    @change="sIdChange($event)"
                                    @visible-change="siVisibleChange($event)"
                                    style="width: 100%"
                                    size="small"
                                >
                                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="发货方式" prop="ShipType">
                                <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%" size="small">
                                    <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="物流公司" prop>
                                <el-input
                                    v-if="dataReadonly"
                                    :title="submitData.LogisticName"
                                    v-model="submitData.LogisticName"
                                    style="width: 100%"
                                    size="small"
                                    :disabled="true"
                                ></el-input>
                                <el-select
                                    v-else
                                    style="width: 100%"
                                    size="small"
                                    v-model="submitData.LogisticItem"
                                    value-key="EntpCusId"
                                    placeholder="请输入物流公司"
                                    filterable
                                    clearable
                                    default-first-option
                                    remote
                                    reserve-keyword
                                    :remote-method="searchLogistic"
                                    @visible-change="logisticVisibleChange($event)"
                                    @change="logisticChange"
                                >
                                    <el-option v-for="item in logisticsList" :key="item.EntpCusId" :data-msg="item" :label="item.EntpCusName" :value="item">
                                        <div class="name">
                                            {{ item.EntpCusName }}
                                            <span class="phone" v-if="item.Phone">
                                                {{ ' ( 电话：' + item.Phone + ' )' }}
                                            </span>
                                        </div>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <div class="customer-view">
                            <el-form-item label="售后原因" prop="Reasons" class="grid-content bg-purple">
                                <el-input size="small" v-model="submitData.Reasons" :disabled="dataReadonly"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="section-title">
            <div>
                <span>退款申请</span>
                <span v-if="type != 1" style="font-size: 14px; color: red">
                    （ ※ 温馨提醒：当申请退款金额为0时，为仅退货的售后
                    {{ type == 4 ? '，确认收款后不可修改' : '' }}）
                </span>
            </div>
        </div>
        <div class="order-infoes">
            <el-form :model="submitData" ref="formMsg2" label-width="100px" style="width: 100%; padding-right: 30px; padding-left: 30px">
                <el-row :gutter="20">
                    <el-col :span="4" v-if="type != 3 && discountMoney > 0">
                        <div class="grid-content bg-purple">
                            <el-form-item label="订单优惠总额">
                                <el-input size="small" v-model="discountMoney" disabled :title="discountMoney"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="discountMoney > 0 ? 4 : 6" v-if="type != 3">
                        <div class="grid-content bg-purple">
                            <el-form-item :label="type == 0 ? '可退款金额' : '退款金额'">
                                <el-input size="small" v-model="returnMoney" disabled :title="returnMoney"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="discountMoney > 0 ? 4 : 6" v-if="type != 3">
                        <div class="grid-content bg-purple">
                            <el-form-item label="已退款金额">
                                <el-input size="small" v-model="refundAmount" disabled :title="refundAmount"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="退款方式">
                                <el-select size="small" v-model="submitData.PayType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%">
                                    <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="申请退款金额">
                                <el-input-number v-model="submitData.ApplyAmount" disabled :min="0" style="width: 100%" size="small"></el-input-number>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- table body -->
        <div class="section-title">
            <div>
                <span>退货商品</span>
                <span v-if="type != 1" style="font-size: 14px; color: red">
                    （ ※ 温馨提醒：当不选择任何退货商品时，为仅退款的售后{{ type == 4 ? '，已入库的不可修改' : '' }}
                    ）
                </span>
            </div>
        </div>
        <div id="infinite-list">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: true }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
                @selection-change="handleSelectionChange"
                empty-text="该售后单无退货商品"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65"></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]">{{ row.GoodName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSerise" title="车型" resizable>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]">{{ row.AutoSerise }}</div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" v-if="isShowBrand" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="120" key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Origin }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" v-if="isSizeShow" title="规格" key="Size" width="90">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" v-if="type == 0 || type == 3" title="可退数量" width="110">
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">可退数量 = 已出仓数 - 已退数量</div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">销售数：{{ row.SaleQuantity }}</div>
                            <div class="div-padding-12">{{ row.CanReturnCount }}</div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="80" v-if="!isBPriceShow" key="Unit">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Unit }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="退货数量" width="110" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div
                            :class="[
                                'div-padding-12',
                                {
                                    'special-border': type == 0 ? row.ReturnCount > row.CanReturnCount : row.ReturnCount == 0
                                }
                            ]"
                        >
                            <span
                                :class="{
                                    'color-red': type == 0 ? row.ReturnCount > row.CanReturnCount : row.ReturnCount == 0
                                }"
                                >{{ row.ReturnCount }}</span
                            >
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                type="number"
                                :ref="'count' + scope.rowIndex"
                                :min="1"
                                :max="type != 0 ? 9999 : scope.row.CanReturnCount"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.ReturnCount"
                                :disabled="dataReadonly || scope.row.IsIn || scope.row.hasLock"
                                @change="priceChange"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="BillingPrice" title="开单价" width="90" v-if="isBPriceShow" key="BillingPrice">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.BillingPrice }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="SalePrice" title="退单价" width="110" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <div :class="{ 'color-red': row.SalePrice === 0 }">{{ row.SalePrice }}</div>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <!--未确认收款收款都可以修改-->
                            <el-input-number
                                size="small"
                                :disabled="dataReadonly || scope.row.hasLock"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.SalePrice"
                                placeholder="退单价"
                                @change="priceChange"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="cgzj" title="退单总价" width="90">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ (row.SalePrice * row.ReturnCount).toFixed(2) }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column title="是否入仓" width="90" v-if="type == 1 || type == 4">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            {{ row.IsIn ? '已入仓' : row.WarehousedCount > 0 ? '部分入仓' : '未入仓' }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="CusSourcesName" v-if="isUseSource" title="订单来源" key="CusSourcesName" width="90">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.CusSourcesName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="OrgName" v-if="isOrgShow" title="部门" key="OrgName" width="90">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.OrgName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="SName" v-if="isBPriceShow" title="开单员" key="SName" width="70">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.SName }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Remark" title="备注" :edit-render="{ autofocus: '.el-input__inner' }" v-if="isRemarkShow">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Remark }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="autoSeriseSelect"
                            v-if="isRemarkSelect"
                            allow-create
                            :disabled="dataReadonly"
                            size="small"
                            v-model="scope.row.Remark"
                            :popper-append-to-body="false"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="选择备注"
                            @keyup.enter.native="keyEvent($event, 'Remark')"
                            @keyup.left.native="keyEvent($event, 'Remark')"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="option in remarkList" :key="option.Value" :data-msg="option" :label="option.Text" :value="option.Text">
                                <div class="option-content">
                                    <div class="project-Name" style="width: 150px">{{ option.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                        <div class="sales-input-cell" v-else>
                            <el-input size="small" :disabled="dataReadonly || scope.row.hasLock" v-model="scope.row.Remark" placeholder=" 请输入备注"></el-input>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="type != 0 && type != 1">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex)"
                                icon="el-icon-delete"
                                v-if="!dataReadonly && (!row.WarehousedCount || row.WarehousedCount <= 0)"
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && !row.IsIn"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="entpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="searchVisible" width="1248px" v-dialog-drag :modal="false" lock-scroll id="search-dialog">
            <div v-if="searchVisible">
                <SearchAP
                    dragSign="SearchReturnAP"
                    :IsBPriceShow="isBPriceShow"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="entpCusName"
                    :DataList="dataList"
                    :IsShowBrand="isShowBrand"
                    @closeDialog="closeSearchDialog"
                ></SearchAP>
            </div>
        </el-dialog>
        <!--   选择销售单    -->
        <el-dialog :close-on-click-modal="false" title="选择需要售后的销售单" :visible.sync="showOrderSearchDialog" width="1200px">
            <div v-if="showOrderSearchDialog">
                <SelectSaleOrder @closeDialog="closeOrderDialog"></SelectSaleOrder>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import APHistory from '@/components/common/APHistory';
import APMsg from '@/components/common/APMsg';
import SearchAP from '@/components/common/APSaleDetailForReturn';
import SelectSaleOrder from '@/components/business/salesManage/selectAfterSaleOrder';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        APMsg,
        APHistory,
        SearchAP,
        SelectSaleOrder
    },
    data() {
        return {
            isCheckCode: true,
            returnCode: '',
            orderCode: '',
            returnMoney: '',
            discountMoney: '',
            EntpTempGoodsIdEdit: '',
            loading: false,
            needConfirm: true,
            dataReadonly: false,
            APMsgVisible: false,
            historyVisible: false,
            searchVisible: false,
            showOrderSearchDialog: false,
            title: '售后开单',
            allNum: 0,
            allMoney: 0,
            refundAmount: 0,
            submitData: {
                WarehouseId: '',
                SReturnId: '', //退货单id
                EntpCusId: '', //客户id
                EntpCusOId: '', //销售单id
                ReturnTime: new Date(),
                ApplyAmount: 0,
                PayType: '',
                Reasons: '',
                SubmissionState: 0,
                DetailList: [],
                OrgId: '',
                OrgName: '',
                OrderSId: '',
                OrderSName: '',
                IsDeduct: false,
                ShipType: '',
                LogisticId: '',
                LogisticName: '',
                LogisticItem: ''
            },
            Limit: 30,
            dataList: [],
            logisticsList: [],
            selectedList: [],
            customerList: [], //客户列表
            warehouseList: [],
            payWayList: [],
            DeliveryMethodList: [], // 发货方式列表
            type: 0, //1查看，0新增-有单，2编辑，3新增-无单，4修改
            pageTitle: '',
            entpCusName: '',
            rules: {
                WarehouseId: [{ required: true, message: '选择仓库', trigger: 'change' }],
                EntpCusId: [{ required: true, message: '选择客户', trigger: 'change' }],
                ReturnTime: [{ required: true, message: '填写售后时间', trigger: 'change' }],
                Reasons: [{ required: true, message: '填写售后原因', trigger: 'change' }],
                OrgId: [{ required: true, message: '请选择部门', trigger: 'change' }]
            },
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            permission: {},
            changeCodeConfig: true,
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            apcodeSource: null, // 用于处理取消编码请求操作
            // 用于客户名称列表，分页搜索
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: true,
            // 阻止提交，防止多次提交
            stopSubmit: false,
            IsIn: false, //订单是否入库
            // 销售无单售后价格默认赋值商品退货价的合计
            xswdtksqConfig: false,
            // 汽配编码排序标识
            sortActive: '',
            isRemarkShow: false,
            isForceRemark: false,
            isOrgShow: false, //开单部门
            isLastOrg: false,
            orgList: [],
            SIdList: [], //销售单的业务员
            orgSelKey: this.$util.guid(),
            isBPriceShow: false, //开单价
            isOriginShow: false, //产地
            isSizeShow: false,
            isUseSource: false, //是否启用销售开单显示来源
            isShowBrand: false, //是否显示品牌
            startAddChace: false,
            isVerifySource: false, //是否检查销售来源是否一致
            IsVerifyOrg:false,//是否检查相同开单部门商品
            isRemarkSelect: false,
            remarkList: []
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    watch: {
        dataList: {
            deep: 'true',
            handler() {
                // 跟单售后触发
                if (this.type * 1 === 0) {
                    this.totalPriceSum();
                }
                if (this.type * 1 != 1 && this.startAddChace) this.addPageChace();
            }
        },
        submitData: {
            handler() {
                if (this.type * 1 != 1 && this.startAddChace) this.addPageChace();
            },
            deep: true
        }
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            return this.infiniteListHeight - 24;
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3, 4].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        }
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getSendWay();
        this.getPay();
        this.$util.getParentOrgs().then(data => {
            this.orgList = data;
        });
        this.type = this.$route.query.type;
    },
    mounted() {
        //销售退货单权限
        this.permission = this.$util.getPermission('goodsReturns');

        this.submitData.SReturnId = this.$route.query.SReturnId;
        this.submitData.EntpCusOId = this.$route.query.id;

        let orderModel = this.$util.getLocalStorage('salesReturnOrder');
        let datalist = this.$util.getLocalStorage('salesReturnOrder_dataList');

        switch (Number(this.type)) {
            case 1:
                this.pageTitle = '查看销售售后单';
                this.dataReadonly = true;
                this.needConfirm = false;
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();
                    this.getReturnOrderDetail();
                });
                break;
            case 2:
                this.pageTitle = '编辑销售售后单';
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();
                    if (orderModel || (datalist && datalist.length > 0)) {
                        this.getDataFromChace();
                    } else {
                        this.getReturnOrderDetail(true);
                    }
                });
                break;
            case 3:
                // 从销售退货页面点击新增销售退货
                this.pageTitle = '新增销售售后单';
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();
                    if (orderModel || (datalist && datalist.length > 0)) {
                        this.getDataFromChace();
                    }
                    // if (this.isOrgShow && this.isLastOrg) {
                    //     this.getLastOrderOrgId();
                    // }
                });
                break;
            case 4:
                this.pageTitle = '修改销售售后单';
                this.getConfigByCodes().then(() => {
                    if (this.isRemarkSelect && this.isRemarkShow) this.getRemarkList();
                    if (orderModel || (datalist && datalist.length > 0)) {
                        this.getDataFromChace();
                    } else {
                        this.getReturnOrderDetail(true);
                    }
                });
                break;
            default:
                break;
        }
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);

        // 监听滚动事件
        window.onresize = () => {
            this.resetHeight();
        };
        setTimeout(() => {
            this.resetHeight();
        }, 0);

        if (!(orderModel || (datalist && datalist.length > 0))) this.startAddChace = true;
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            let key = window.event.keyCode;
            if (key == 112) {
                e.preventDefault();
                that.goback();
                return;
            }
            if (key == 113) {
                e.preventDefault();
                if (!that.searchVisible) that.showSearch();
                return;
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'kdbjsd',
                    'ddhhm',
                    'kdyjz',
                    'xswdtksq',
                    'xsthspzsbz',
                    'xsspbzbt',
                    'xskdxskdbm',
                    'xskdxskdj',
                    'kdspcd',
                    'kdspgg',
                    'xsddly',
                    'kdxspp',
                    'ssxsmxxzspsfxzly',
                    'xzqpbmdwyx',
                    'xsthspxzbz',
                    'xsthspbxtbm'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'kdbjsd': //选择商品完成回车或点加号后触发锁定不可修改
                                    this.hasLock = result;
                                    break;
                                case 'ddhhm': // 是否展示互换码
                                    this.changeCodeConfig = result;
                                    break;
                                case 'kdyjz': // 获取预加载商品数据的功能设置结果
                                    this.isPreloadApCodeList = result;
                                    break;
                                case 'xswdtksq': // 销售无单售后价格默认赋值商品退货价的合计
                                    this.xswdtksqConfig = result;
                                    break;
                                case 'xsthspzsbz': //展示备注列
                                    this.isRemarkShow = result;
                                    break;
                                case 'xsspbzbt': //备注必填
                                    this.isForceRemark = result;
                                    break;
                                case 'xskdxskdbm': //开单部门
                                    this.isOrgShow = result;
                                    break;
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'kdspcd': //是否出现产地
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg': //是否出现规格
                                    this.isSizeShow = result;
                                    break;
                                case 'xsddly': //是否启用销售开单显示来源
                                    this.isUseSource = result;
                                    break;
                                case 'kdxspp': //是否显示品牌
                                    this.isShowBrand = result;
                                    break;
                                case 'ssxsmxxzspsfxzly': //是否检查销售来源是否一致
                                    this.isVerifySource = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'xsthspxzbz': //是否检测编码重复
                                    this.isRemarkSelect = result;
                                    break;
                                case 'xsthspbxtbm'://是否检查相同开单部门商品
                                    this.IsVerifyOrg = result;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        // 搜索客户
        searchCustomer(key) {
            this.loading = true;
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.customerList = [...this.customerList, ...data];
                if (this.customerList.length > 0) {
                    let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                    if (currCust) {
                        this.entpCusName = currCust.EntpCusName;
                    }
                }
            });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getReturnOrderDetail();
            }
        },
        checkCodeRepeat() {
            let obj = {};
            let result;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!obj[_dataList[i].APCode]) {
                    obj[_dataList[i].APCode] = [i];
                } else {
                    obj[_dataList[i].APCode].push(i);
                }
            }
            for (let key in obj) {
                if (obj[key].length >= 2) {
                    return false;
                } else {
                    result = true;
                }
            }
            return result;
        },
        // 数量或者价格变动
        priceChange(changeApply = true) {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].SaleQuantity);
                _allMoney += Number(DetailList[i].ReturnCount * DetailList[i].SalePrice ? DetailList[i].ReturnCount * DetailList[i].SalePrice : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            if (this.xswdtksqConfig) {
                //编辑初始化的时候不从这里赋值
                if (typeof changeApply === 'number' || (typeof changeApply === 'boolean' && changeApply)) {
                    this.$nextTick(() => {
                        this.submitData.ApplyAmount = _allMoney.toFixed(2);
                    });
                }
            }
        },
        // 获取销售售后单详情
        getReturnOrderDetail(hasLock) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetSaleReturnOrderDetail_V3',
                    data: {
                        SReturnId: that.submitData.SReturnId
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (Number(that.type) !== 1) that.dataReadonly = data.ApplyIsConfirm; //当退货单被财务确认了单据后，不能再进行修改
                    data.LogisticItem = data.LogisticName;
                    let i = that.customerList.findIndex(item => {
                        if (item.EntpCusId == data.EntpCusId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        that.customerList.push({
                            EntpCusId: data.EntpCusId,
                            EntpCusName: data.EntpCusName
                        });
                        that.entpCusName = data.EntpCusName;
                    }

                    if (data.WarehouseId) {
                        let iw = that.warehouseList.findIndex(item => {
                            if (item.WarehouseId == data.WarehouseId) {
                                return true;
                            }
                        });
                        if (iw == -1) {
                            that.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType
                            });
                        }
                    }
                    let ip = that.payWayList.findIndex(item => {
                        if (item.Value == data.PayType) {
                            return true;
                        }
                    });
                    if (ip == -1) {
                        that.payWayList.push({
                            Value: data.PayType,
                            Text: data.PayTypeName
                        });
                    }
                    if (data.OrderSId) {
                        that.SIdList.push({
                            EmployeeId: data.OrderSId,
                            EmployeeName: data.OrderSName
                        });
                    }
                    if (that.isOrgShow && data.OrgId) {
                        if (!that.orgList.find(item => item.Id == data.OrgId)) that.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                    }
                    if (that.hasLock) {
                        data.DetailList.forEach(ele => {
                            ele.hasLock = hasLock;
                        });
                    } else {
                        data.DetailList.forEach(ele => {
                            ele.hasLock = false;
                        });
                    }
                    that.submitData = data;
                    that.returnMoney = data.Paid;
                    that.discountMoney = data.DiscountAmount;
                    that.refundAmount = data.RefundAmount;
                    that.returnCode = data.ReturnCode;
                    that.orderCode = data.OrderCode;
                    that.dataList = data.DetailList;
                    that.submitData.EntpCusId = data.EntpCusId;
                    that.IsIn = data.IsIn;
                    that.priceChange(false);
                })
                .catch(error => {});
        },
        // 提交销售售后单
        submitForm(SubmissionState) {
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = [];
                    if (this.type == 0) _dataList = this.selectedList;
                    else {
                        if (this.dataList.length > 0) {
                            this.dataList.forEach(item => {
                                if (item.EntpTempGoodsId) _dataList.push(item);
                            });
                        }
                    }

                    if (_dataList.length == 0 && this.submitData.ApplyAmount == 0) {
                        this.$util.warningMsg('售后必须至少具备退货或退款其中一项');
                        return;
                    }

                    if (this.submitData.ApplyAmount > 0) {
                        if (!this.submitData.PayType) {
                            this.$util.warningMsg('当申请退款时，退款方式必须选择哟');
                            return;
                        }
                    }

                    if (this.submitData.PayType) {
                        let ml = this.payWayList.filter(f => f.Value === this.submitData.PayType);
                        if (ml.length > 0) {
                            let m = ml[0];
                            if (m.IsSecSpecial) {
                                if (!this.submitData.LogisticId) {
                                    this.$util.warningMsg('当支付方式为托收类型时，物流公司必须进行选择');
                                    return;
                                }
                            }
                        } else {
                            this.$util.warningMsg('支付方式异常，请重新选择支付方式');
                            return;
                        }
                    }

                    let isNotEqual_S = false;
                    let isNotEqual_O = false;
                    let preValue_S = _dataList[0]['CusSourcesName']; // 默认第一项
                    let preValue_O = _dataList[0]['OrgName'];
                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }

                        if (!_dataList[i].ReturnCount || _dataList[i].ReturnCount <= 0) {
                            this.$util.warningMsg('请填写正确的退货数量');
                            return;
                        }
                        
                        if (!_dataList[i].IsIn && _dataList[i].CanReturnCount && _dataList[i].ReturnCount > _dataList[i].CanReturnCount) {
                            this.$util.warningMsg('可退货数量不足');
                            return;
                        }
                        if (!_dataList[i].IsIn && _dataList[i].WarehousedCount > 0 && _dataList[i].ReturnCount < _dataList[i].WarehousedCount) {
                            this.$util.warningMsg('退货数量不能少于已入仓数，已入仓' + _dataList[i].WarehousedCount + '个商品');
                            return;
                        }
                        if (this.isRemarkShow && this.isForceRemark && !_dataList[i].Remark) {
                            this.$util.warningMsg('请填写备注');
                            return;
                        }
                        if (this.isRemarkSelect && _dataList[i].Remark) {
                            var index = this.remarkList.findIndex(x => x.Text == _dataList[i].Remark);
                            if (index >= 0) {
                                _dataList[i].RemarkId = this.remarkList[index].Id;
                            } else {
                                _dataList[i].RemarkId = '';
                            }
                        } else {
                            _dataList[i].RemarkId = '';
                        }
                        if (!isNotEqual_S) {
                            isNotEqual_S = preValue_S != _dataList[i].CusSourcesName;
                        }
                        if (!isNotEqual_O) {
                            isNotEqual_O = preValue_O != _dataList[i].OrgName;
                        }
                    }

                    if (isNotEqual_S && this.isVerifySource) {
                        this.$util.warningMsg('请选择相同销售来源的商品明细');
                        return;
                    } else if (isNotEqual_O && this.isBPriceShow&&this.IsVerifyOrg) {
                        this.$util.warningMsg('请选择相同部门的销售明细');
                        return;
                    }
                    this.submitData.SubmissionState = SubmissionState;
                    this.submitData.DetailList = _dataList;
                    this.submitFormAgain(SubmissionState);
                } else {
                    this.$util.warningMsg('有必填项未填写');
                }
            });
        },
        submitFormAgain(SubmissionState) {
            let that = this;
            that.stopSubmit = true;
            let url = '';
            if (that.type == 4) {
                url = '/api/EntpSaleReturnOrder/SaveSaleReturnOrderAfterSubmit_V3';
            } else {
                url = '/api/EntpSaleReturnOrder/SaveEntpSaleReturnOrder_V3';
            }
            that.$util
                .axiosPost({
                    url: url,
                    data: that.submitData
                })
                .then((res) => {
                    that.needConfirm = false;
                    if (SubmissionState) {
                        that.$util.successMsg('提交销售售后单成功');
                    } else {
                        that.$util.successMsg('保存销售售后单成功');
                    }
                    that.removePageChace();

                    that.$store.commit('updateNeedRefresh', true);
                    if (that.type == 3) that.$store.commit('updateOrderList', { Id: res.data, IsAdd: true });
                    else that.$store.commit('updateOrderList', { Id: that.submitData.SReturnId, IsAdd: false });

                    //添加默认部门销售售后不给保存后改部门
                    if (that.isOrgShow && that.isLastOrg && that.submitData.OrgId && (that.type == 0 || that.type == 3)) {
                        var og = {
                            OrgId: that.submitData.OrgId,
                            OrgName: that.submitData.OrgName,
                        };
                        let CacheList = [];
                        CacheList.push({ CacheKey: 'LastOrderOrg', CacheValue: JSON.stringify(og), CacheType: '1' });
                        that.$util.SetEntpCache(CacheList);
                    }

                    setTimeout(() => {
                        this.$router.push('/salesManage/salesReturns');
                    }, 2000);
                })
                .catch(() => {
                    this.stopSubmit = false;
                });
        },
        //从缓存中读取上次开单的部门
        getLastOrderOrgId() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                if(this.orgList.length == 0){
                    this.$util.getParentOrgs().then(data => {
                        this.orgList = data;
                        this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                         if (result) {
                                let orgdata = JSON.parse(result);
                                if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                    this.submitData.OrgId = orgdata.OrgId;
                                    this.submitData.OrgName = orgdata.OrgName;
                                }
                            }
                            resolve();
                        });
                    });
                }else
                    this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                        if (result) {
                            let orgdata = JSON.parse(result);
                            if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                this.submitData.OrgId = orgdata.OrgId;
                                this.submitData.OrgName = orgdata.OrgName;
                            }
                        }
                        resolve();
                    });
                
            });
        },
        // 将退款方式存入缓存
        setRefundLocalStorage() {
            let refundMethod = this.$util.getLocalStorage('salesRefundMethod');
            if (!Array.isArray(refundMethod)) refundMethod = [];
            let fIdx = refundMethod.findIndex(f => f.EntpCusId === this.submitData.EntpCusId);
            if (fIdx > -1) {
                refundMethod[fIdx].PayType = this.submitData.PayType;
            } else {
                refundMethod.push({
                    EntpCusId: this.submitData.EntpCusId,
                    PayType: this.submitData.PayType
                });
            }
            this.$util.setLocalStorage('salesRefundMethod', refundMethod);
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
        },
        // 删除某行
        delItem(index) {
            this.dataList.splice(index, 1);
            this.priceChange();
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        //当客户下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        that.warehouseType = that.warehouseList[i].Type;
                        break;
                    }
                }
            }
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        setSummaries(param) {
            let count = this.dataList.reduce((p, i) => p + Number(i.ReturnCount), 0);
            var countColIndex = 0;
            var sumColIndex = 0;
            countColIndex = param.columns.findIndex(item => {
                return item.title == '退货数量';
            });
            sumColIndex = param.columns.findIndex(item => {
                return item.title == '退单总价';
            });

            var arr = new Array(param.columns.length);
            if (countColIndex != -1) {
                arr[countColIndex] = count;
                arr[countColIndex - 1] = '总数量';
            }
            if (sumColIndex != -1) {
                arr[sumColIndex] = this.allMoney.toFixed(2);
                arr[sumColIndex - 1] = '合计';
            }
            return [arr];
        },
        GetSaleOrderDetail() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetSaleOrderToReturn',
                    data: { EntpCusOId: that.submitData.EntpCusOId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    data.LogisticItem = data.LogisticName;
                    let i = that.customerList.findIndex(item => {
                        if (item.EntpCusId == res.data.EntpCusId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        that.customerList.push({
                            EntpCusId: res.data.EntpCusId,
                            EntpCusName: res.data.EntpCusName
                        });
                        that.entpCusName = res.data.EntpCusName;
                    }

                    if (res.data.WarehouseId) {
                        let iw = that.warehouseList.findIndex(item => {
                            if (item.WarehouseId == res.data.WarehouseId) {
                                return true;
                            }
                        });
                        if (iw == -1) {
                            that.warehouseList.push({
                                WarehouseId: res.data.WarehouseId,
                                WarehouseName: res.data.WarehouseName,
                                Type: res.data.WarehouseType
                            });
                        }
                    }
                    let ip = that.payWayList.findIndex(item => {
                        if (item.Value == res.data.PayType) {
                            return true;
                        }
                    });
                    if (ip == -1) {
                        that.payWayList.push({
                            Value: res.data.PayType,
                            Text: res.data.PayTypeName
                        });
                    }

                    if (data.OrderSId) {
                        that.SIdList.push({
                            EmployeeId: data.OrderSId,
                            EmployeeName: data.OrderSName
                        });
                    }
                    if (that.isOrgShow && data.OrgId) {
                        if (!that.orgList.find(item => item.Id == data.OrgId)) that.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                    }
                    that.submitData = data;
                    that.returnMoney = data.Paid;
                    that.discountMoney = data.DiscountAmount;
                    that.refundAmount = data.RefundAmount;
                    that.returnCode = '';
                    that.orderCode = data.OrderCode;
                    that.dataList = data.DetailList;

                    this.$nextTick(() => {
                        that.priceChange();
                    });
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode) rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        handleSelectionChange(val) {
            this.selectedList = [];
            if (val) this.selectedList = val;
            this.totalPriceSum();
        },
        // 计算申请退款金额
        totalPriceSum() {
            let num = this.selectedList.reduce((r, e) => r + e.SalePrice * e.ReturnCount, 0);
            this.submitData.ApplyAmount = num.toFixed(2);
        },
        selectCustomerChange(val) {
            let that = this;
            if (!val) {
                that.submitData.EntpCusName = '';
                return;
            }
            let rowArr = this.customerList.filter(f => f.EntpCusId === val);
            if (rowArr.length == 1) {
                that.entpCusName = rowArr[0].EntpCusName;
                that.submitData.EntpCusName = rowArr[0].EntpCusName;
            }
            that.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: that.submitData.EntpCusId,
                        type: '2'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data && data.PayType) {
                        that.submitData.PayType = data.PayType;
                        let payType = that.payWayList.find(e => e.Value == data.PayType);
                        if (!payType) {
                            that.payWayList.push({
                                Value: data.PayType,
                                Text: data.PayTypeName
                            });
                        }
                    }

                    that.dataList = [];
                });
        },
        // 搜索
        showSearch() {
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择客户');
                return;
            }
            if (this.entpCusName) this.title = '【' + this.entpCusName + '】销售数据';
            else this.title = '销售数据';
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 关闭弹框并更新页面数据
        closeSearchDialog(items, noClose = false) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                if (!noClose) {
                    that.searchVisible = false;
                    return;
                }
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];

                if (that.submitData.OrgId != item.OrgId) {
                    that.submitData.OrgId = item.OrgId;
                }

                let newGoods = {
                    ReferencePrice: item.ReferencePrice,
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodsName,
                    AutoSerise: item.AutoSerise,
                    ReturnCount: item.WarehousedCount - item.AlReturnCount > 0 ? item.WarehousedCount - item.AlReturnCount : 0,
                    Unit: item.Unit,
                    SalePrice: item.SalePrice,
                    State: item.State,
                    SaleQuantity: item.SaleQuantity,
                    CanReturnCount: item.WarehousedCount - item.AlReturnCount,
                    SaleOrderRsId: item.SaleOrderRsId,
                    Size: item.Size,
                    Origin: item.Origin,
                    BillingPrice: item.BillingPrice,
                    SName: item.SName,
                    OrgName: item.OrgName,
                    OrgId: item.OrgId,
                    CostPrice: item.CostPrice,
                    CusSourcesName: item.CusSourcesName,
                    Brand: item.Brand
                };

                newGoodsList.push(newGoods);
            }

            //判断最后一条数据是否空值，是的话移到最后，noClose 表示不关闭弹框
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            that.priceChange();
            if (!noClose) {
                that.searchVisible = false;
            }
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        filterAPCodeMethod({ option, row }) {
            let val = option.data.replace(/(^\s*)|(\s*$)/g, '');
            if (val) {
                val = val.toUpperCase();
            }
            return row.APCode.toUpperCase().indexOf(val) != -1;
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgList.length <= 1)
                    that.$util.getParentOrgs().then(data => {
                        that.orgList = data;
                    });
            }
        },
        orgChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.orgList.length; i++) {
                    if (val == that.orgList[i].Id) {
                        that.submitData.OrgName = that.orgList[i].Name;
                        break;
                    }
                }
            } else {
                that.submitData.OrgName = '';
            }
        },
        //业务员改变
        sIdChange(value) {
            let _list = this.SIdList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.OrderSName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event && that.SIdList.length <= 1) {
                that.$util.getCommonSIdList().then(data => {
                    that.SIdList = data;
                });
            }
        },
        //获取备注下拉列表
        getRemarkList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAttrs2?attrCode=sOrderReason',
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.remarkList = data;
                    }
                });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        logisticVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.logisticsList.length == 0) that.searchLogistic();
            }
        },
        searchLogistic(key) {
            this.loading = true;
            this.$util
                .searchLogistic(key, 1, this.Limit)
                .then(data => {
                    this.logisticsList = data ? data : [];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        logisticChange(item) {
            if (!item) {
                this.submitData.LogisticName = '';
                this.submitData.LogisticId = '';
                this.submitData.LogisticItem = '';
            } else if (typeof item == 'string') {
                this.submitData.LogisticName = item;
                this.submitData.LogisticId = '';
            } else {
                this.submitData.LogisticName = item.EntpCusName;
                this.submitData.LogisticId = item.EntpCusId;
            }
        },
        goback() {
            this.$router.push('/salesManage/salesReturns');
        },
        showOrderDialog() {
            this.showOrderSearchDialog = true;
        },
        closeOrderDialog(arr) {
            let that = this;
            that.showOrderSearchDialog = false;
            if (arr[0]) {
                that.submitData.EntpCusOId = arr[0];
                that.GetSaleOrderDetail();
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$set(this.submitData, 'returnMoney', this.returnMoney);
            this.$set(this.submitData, 'discountMoney', this.discountMoney);
            this.$set(this.submitData, 'refundAmount', this.refundAmount);
            this.$set(this.submitData, 'orderCode', this.orderCode);
            this.$set(this.submitData, 'returnCode', this.returnCode);
            this.$set(this.submitData, 'IsIn', this.IsIn);
            this.$util.setLocalStorage('salesReturnOrder', this.submitData);
            this.$util.setLocalStorage('salesReturnOrder_dataList', this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('salesReturnOrder');
            this.$util.clearLocalStorage('salesReturnOrder_dataList');
        },
        //从缓存中读取数据
        getDataFromChace() {
            let data = this.$util.getLocalStorage('salesReturnOrder');
            let datalist = this.$util.getLocalStorage('salesReturnOrder_dataList');
            let that = this;
            if (data) {
                if (Number(that.type) !== 1) that.dataReadonly = data.ApplyIsConfirm; //当退货单被财务确认了单据后，不能再进行修改
                data.LogisticItem = data.LogisticName;
                let i = that.customerList.findIndex(item => {
                    if (item.EntpCusId == data.EntpCusId) {
                        return true;
                    }
                });
                if (i == -1) {
                    that.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    that.entpCusName = data.EntpCusName;
                }

                if (data.WarehouseId) {
                    let iw = that.warehouseList.findIndex(item => {
                        if (item.WarehouseId == data.WarehouseId) {
                            return true;
                        }
                    });
                    if (iw == -1) {
                        that.warehouseList.push({
                            WarehouseId: data.WarehouseId,
                            WarehouseName: data.WarehouseName,
                            Type: data.WarehouseType
                        });
                    }
                }
                let ip = that.payWayList.findIndex(item => {
                    if (item.Value == data.PayType) {
                        return true;
                    }
                });
                if (ip == -1) {
                    that.payWayList.push({
                        Value: data.PayType,
                        Text: data.PayTypeName
                    });
                }
                if (data.OrderSId) {
                    that.SIdList.push({
                        EmployeeId: data.OrderSId,
                        EmployeeName: data.OrderSName
                    });
                }
                if (that.isOrgShow && data.OrgId) {
                    if (!that.orgList.find(item => item.Id == data.OrgId)) that.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                }

                that.submitData = data;
                that.returnMoney = data.returnMoney;
                that.discountMoney = data.discountMoney;
                that.refundAmount = data.refundAmount;
                that.returnCode = data.returnCode;
                that.orderCode = data.orderCode;
                that.IsIn = data.IsIn;
            }

            if (datalist && datalist.length > 0) {
                that.dataList = datalist;
            }
            that.priceChange(false);
            this.startAddChace = true;
        }
    }
};
</script>
<style lang="less" scoped>
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;

    span {
        margin-right: 20px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    padding-top: 30px;
    margin-right: 110px;
    text-align: right;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 0;
    z-index: 2;
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
.info-cus-icon {
    width: 25px;
    height: 25px;
    margin-right: 4px;
    margin-top: -4px;
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .color-red {
        margin-right: 4px;
    }
    .sort-view {
        display: flex;
        flex-direction: column;
        i {
            line-height: 8px;
            cursor: pointer;
        }
        .active {
            color: #409eff;
        }
    }
}
.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .customer-checked {
        margin-left: 24px;
    }
}
</style>
<style lang="less">
.salereturn-order-edit {
    width: 100%;
    padding: 10px 20px 0px 20px;

    .order-infoes {
        border: 1px solid @border3Color;
        padding-top: 10px;
        margin-bottom: 10px;

        .grid-content {
            border-radius: 4px;
            min-height: 32px;
        }
        .el-form-item {
            margin-bottom: 0px;
            line-height: 32px;
            height: 32px;
        }

        .el-form-item__label {
            line-height: 32px;
            height: 32px;
        }

        .el-form-item__content {
            line-height: 32px !important;
            height: 32px;
            top: -1px;
        }
    }
    .el-row {
        margin-bottom: 10px !important;

        &:last-child {
            margin-bottom: 10px !important;
        }
    }

    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 220px !important;

            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .table-check {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 10px;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
</style>
